import { create } from 'zustand'

type TConversationStore = {
  unread: boolean
  setUnread: (unread: boolean) => void
}

export const useConversationsListStore = create<TConversationStore>((set) => ({
  unread: false,
  setUnread: (unread) => set({ unread }),
}))
